// Danh update price

function getCalculatedPrice() {
    const priceEl = document.querySelector('.calc-total-price');
    if (!priceEl) {
        return 0;
    }
    let priceText = priceEl.textContent.trim();

    priceText = priceText
        .replace('€', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');

    return parseFloat(priceText) || 0;
}
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.calc-btn');
    if (!btn) return;
    e.preventDefault();
    const calculatedPrice = getCalculatedPrice();
    const quantity = Number(
        document.querySelector('[name="quantity"]')?.value || 1
    );
    fetch('https://serverwaketo1001.de/shopify-app/kalte4you/update-price/create-custom-price-checkout.php', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          title: window.customDraftProduct.productTitle,
          price: calculatedPrice,
          quantity: quantity,
          properties: {
              Typ: 'Rahmenprofil',
              BerechneterPreis: calculatedPrice.toFixed(2) + ' €',
              _checkout_only: 'true'
              
          }
      })
  })
  .then(res => res.json())
  .then(data => {
      console.log(data);

      if (data.success && data.checkout_url) {
          window.location.href = data.checkout_url;
          return;
      }

      alert(JSON.stringify(data, null, 2));
  });
});
// (function () {

//     const API_URL = 'https://serverwaketo1001.de/shopify-app/kalte4you/update-price/create-custom-price-variant.php';

//     function getCalculatedPrice() {
//         return 98.13;
//     }

//     function getQuantity() {
//         const input = document.querySelector(
//             'form[action="/cart/add"] input[name="quantity"]'
//         );

//         if (!input) {
//             return 1;
//         }

//         const qty = Number(input.value || 1);

//         return qty > 0 ? qty : 1;
//     }

//     function getProductForm() {
//         return document.querySelector(
//             'form[action="/cart/add"]'
//         );
//     }

//     function setProductVariantId(variantId) {
//         const form = getProductForm();

//         if (!form) {
//             alert('Không tìm thấy form add to cart');
//             return false;
//         }

//         const variantInput = form.querySelector(
//             'input[name="id"]'
//         );

//         if (!variantInput) {
//             alert('Không tìm thấy input variant id');
//             return false;
//         }

//         variantInput.value = variantId;

//         variantInput.dispatchEvent(
//             new Event('change', {
//                 bubbles: true
//             })
//         );

//         return true;
//     }

//     function addVariantToCart(variantId, calculatedPrice) {
//         return fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//                 id: Number(variantId),
//                 quantity: getQuantity(),
//                 properties: {
//                     Typ: 'Rahmenprofil',
//                     BerechneterPreis: calculatedPrice.toFixed(2)
//                 }
//             })
//         }).then(function (res) {
//             return res.json();
//         });
//     }

//     function createCustomVariant(calculatedPrice) {
//         if (
//             !window.customPriceProduct ||
//             !window.customPriceProduct.productGid ||
//             !window.customPriceProduct.productGid.includes('gid://shopify/Product/')
//         ) {
//             return Promise.reject(
//                 new Error(
//                     'Invalid product GID: ' +
//                     JSON.stringify(window.customPriceProduct)
//                 )
//             );
//         }

//         return fetch(API_URL, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//                 product_gid: window.customPriceProduct.productGid,
//                 price: calculatedPrice,
//                 quantity: getQuantity(),
//                 option_name: 'Custom Preis',
//                 option_value: 'Rahmenprofil ' + calculatedPrice.toFixed(2)
//             })
//         }).then(function (res) {
//             return res.json();
//         });
//     }

//     function handleCustomAddToCart(event) {
//         const button = event.target.closest('.calc-btn');

//         if (!button) {
//             return;
//         }

//         event.preventDefault();
//         event.stopPropagation();
//         event.stopImmediatePropagation();

//         const calculatedPrice = Number(getCalculatedPrice());

//         if (!calculatedPrice || calculatedPrice <= 0) {
//             alert('Giá tính toán không hợp lệ');
//             return;
//         }

//         button.setAttribute('disabled', 'disabled');
//         button.classList.add('loading');

//         createCustomVariant(calculatedPrice)
//             .then(function (data) {
//                 console.log('Create variant response:', data);

//                 if (!data.success) {
//                     throw new Error(JSON.stringify(data, null, 2));
//                 }

//                 const variantId = Number(data.variant_id);

//                 if (!variantId) {
//                     throw new Error('Variant ID không hợp lệ');
//                 }

//                 setProductVariantId(variantId);

//                 return new Promise(function (resolve) {
//                     setTimeout(function () {
//                         resolve(variantId);
//                     }, 5000);
//                 });
//             })
//             .then(function (variantId) {
//                 return addVariantToCart(variantId, calculatedPrice);
//             })
//             .then(function (cartData) {
//                 console.log('Cart add response:', cartData);

//                 if (cartData.status && cartData.status >= 400) {
//                     throw new Error(JSON.stringify(cartData, null, 2));
//                 }

//                 window.location.href = '/cart';
//             })
//             .catch(function (error) {
//                 console.error(error);
//                 alert(error.message);
//             })
//             .finally(function () {
//                 button.removeAttribute('disabled');
//                 button.classList.remove('loading');
//             });
//     }

//     document.addEventListener(
//         'click',
//         handleCustomAddToCart,
//         true
//     );

// })();
// document.addEventListener('click', function(e) {
//     const btn = e.target.closest('.calc-btn');

//     if (!btn) return;

//     e.preventDefault();

//     const calculatedPrice = 98.13;

//     const quantity = Number(
//         document.querySelector('[name="quantity"]')?.value || 1
//     );

//     fetch('https://serverwaketo1001.de/shopify-app/kalte4you/update-price/create-custom-price-checkout.php', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             title: 'Gummidichtung FD274 / JCR-002',
//             variant_title: 'Rahmenprofil',
//             price: calculatedPrice,
//             quantity: quantity,
//             properties: {
//                 Typ: 'Rahmenprofil',
//                 A: document.querySelector('#input-a')?.value || '',
//                 B: document.querySelector('#input-b')?.value || ''
//             }
//         })
//     })
//     .then(res => res.json())
//     .then(data => {
//         console.log(data);

//         if (data.success && data.checkout_url) {
//             window.location.href = data.checkout_url;
//             return;
//         }

//         alert(JSON.stringify(data, null, 2));
//     })
//     .catch(error => {
//         console.error(error);
//         alert('API error: ' + error.message);
//     });
// });